<template>
  <div id="per_center">
    <!-- 深色舞台头图横幅（静态装饰，匹配 youxuan-content.html .cbanner） -->
    <section class="cbanner">
      <div class="bg"></div>
      <div class="grid-lines"></div>
      <div class="eyebrow">HELP CENTER</div>
      <h1>帮助<em>中心</em></h1>
      <div class="en">Buyer · Seller · After-Sale · FAQ</div>
      <span class="gno">?</span>
    </section>
    <div class="main">
      <div class="main_top">
        <div class="main_top_wrapper">
          <div class="help_title">如何一键玩转游选</div>
          <div>
            <el-input
              placeholder="请输入问题关键词"
              clearable
              @keydown.enter.native="handleSearch"
              v-model.trim="keyWord">
              <span slot="prefix">
                <img src="@/assets/image/HelpCenter/search.png">
              </span>
            </el-input>
          </div>
        </div>
      </div>
      <div class="main_content">
        <div class="help_question">
          <div class="question_top">
            <el-card shadow="hover" :body-style="card_style" @click.native="goHelpDetail(buyMenu.cat_id,buyMenu.id)">
              <img src="@/assets/image/HelpCenter/buy.png">
              买家相关
            </el-card>
            <el-card shadow="hover" :body-style="card_style" @click.native="goHelpDetail(sellMenu.cat_id,sellMenu.id)">
              <img src="@/assets/image/HelpCenter/sell.png">
              卖家相关
            </el-card>
            <el-card shadow="hover" :body-style="card_style" @click.native="goHelpDetail(afterMenu.cat_id,afterMenu.id)">
              <img src="@/assets/image/HelpCenter/afterbuy.png">
              售后相关
            </el-card>
            <el-card shadow="hover" :body-style="card_style" @click.native="goHelpDetail(otherMenu.cat_id,otherMenu.id)">
              <img src="@/assets/image/HelpCenter/other.png">
              其他相关
            </el-card>
          </div>
          <div class="question_middle" @click="goHelpDetail(buyMenu.cat_id,buyMenu.id)">
            <div class="title">全部问题</div>
            <span class="text_dec">针对用户常见的使用问题，答案都在这里哦～</span>
            <el-button type="primary" round class="qes_btn" @click="goHelpDetail(buyMenu.cat_id,buyMenu.id)">查看详情<i class="el-icon-arrow-right"></i></el-button>
          </div>
          <div class="question_bottom" @mouseenter="on_bot_enter" @mouseleave="on_bot_leave">
            <swiper
              :options="swiperOption"
              ref="mySwiper">
              <swiper-slide v-for="item in allQuestion" :key="item.id" >
                <div @click="goHelpDetail(item.cat_id,item.id)">
                  <div class="swiper_top">
                    <el-tooltip class="item" effect="dark" :content="item.title" placement="top">
                      <span class="swiper_title">
                        <img src="@/assets/image/HelpCenter/swiperlt.png">
                        <span class="swiper_title_text">{{ item.title }}</span>
                      </span>
                    </el-tooltip>
                  </div>
                  <router-link class="detail_btn" :to="{name: 'helpDetail',query: {id: item.id,cat_id: item.cat_id}}">查看详情<i class="el-icon-arrow-right"></i></router-link>
                </div>
              </swiper-slide>
              <div class="swiper-button-prev" slot="button-prev">
                <i class="el-icon-arrow-left"></i>
              </div>
              <div class="swiper-button-next" slot="button-next">
                <i class="el-icon-arrow-right"></i>
              </div>
            </swiper>
          </div>
          <!-- <div class="question_tip">
            找不到答案？<a>点击联系在线客服<i class="el-icon-arrow-right"></i><i class="el-icon-arrow-right"></i></a>
          </div> -->
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { apiHelpCenter, apiHelpAll, apiHelpDetail, apiHelpSearch } from "@/request/API";
import "swiper/dist/css/swiper.css";
export default {
  name: '',
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      keyWord: '',
      card_style: {
        display:'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%',
        height: '136px',
        boxSizing: 'border-box'
      },
      btnplay: true,
      swiperOption: {
        slidesPerView: 6,
        spaceBetween: 20,
        slidesPerGroup: 1,
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      buyMenu: {},
      sellMenu: {},
      otherMenu: {},
      afterMenu: {},
      allQuestion: []
    }
  },
  methods: {
    goHelpDetail(cat_id, id) {
      this.$router.push({
        name: 'helpDetail',
        query: {
          cat_id,
          id
        }
      })
    },
    handleSearch() {
      this.$router.push({
        name:'helpCenterSearch',
        query:{
          keyWord: this.keyWord
        }
      })
    },
     on_bot_enter() {
        this.swiper.autoplay.stop();
    },
    on_bot_leave() {
        this.swiper.autoplay.start();
    },
  },
  created() {
    apiHelpCenter().then(res => {
      let array = res.data
      array.map(item => {
        if(item.cat_id == 9){
          this.buyMenu.cat_id = 9
          this.buyMenu.id = item.list[0].id
        } else if(item.cat_id == 10){
          this.sellMenu.cat_id = 10
          this.sellMenu.id = item.list[0].id
        } else if(item.cat_id == 11){
          this.afterMenu.cat_id = 11
          this.afterMenu.id = item.list[0].id
        } else if(item.cat_id == 12){
          this.otherMenu.cat_id = 12
          this.otherMenu.id = item.list[0].id
        }
      });
    })
    apiHelpAll().then(res => {
      this.allQuestion = res.data.list
    })
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  }
}
</script>

<style lang='less' scoped>
#per_center {
  width: 1200px;
  margin-top: 14px;
  display: flex;
  flex-direction: column;
  min-height: 644px;
  background: var(--bg-page, #F7F5F2);

  /* 深色舞台头图横幅 */
  .cbanner {
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    background: var(--bg-stage, #0E1116);
    padding: 38px 40px;
    margin-bottom: 18px;

    .bg {
      position: absolute;
      inset: 0;
      background:
        radial-gradient(120% 90% at 82% 8%, rgba(255, 90, 31, .20), transparent 55%),
        linear-gradient(115deg, #171b22 0%, #0e1116 60%, #1d1410 100%);
    }

    .grid-lines {
      position: absolute;
      inset: 0;
      background-image:
        linear-gradient(rgba(255, 255, 255, .03) 1px, transparent 1px),
        linear-gradient(90deg, rgba(255, 255, 255, .03) 1px, transparent 1px);
      background-size: 40px 40px;
      mask-image: linear-gradient(180deg, transparent, #000 70%);
      -webkit-mask-image: linear-gradient(180deg, transparent, #000 70%);
    }

    .eyebrow {
      position: relative;
      font-size: 11px;
      letter-spacing: 2px;
      color: var(--primary, #FF5A1F);
      font-weight: 700;
      margin-bottom: 10px;
    }

    h1 {
      position: relative;
      color: #fff;
      font-size: 32px;
      font-weight: 900;
      letter-spacing: -1px;
      line-height: 1.1;
      margin: 0;

      em {
        font-style: normal;
        color: var(--primary, #FF5A1F);
      }
    }

    .en {
      position: relative;
      color: #8b919c;
      font-size: 13px;
      margin-top: 10px;
      letter-spacing: 1px;
    }

    .gno {
      position: absolute;
      right: 32px;
      bottom: -22px;
      font-style: italic;
      font-weight: 900;
      font-size: 120px;
      color: rgba(255, 255, 255, .05);
      line-height: 1;
    }
  }

  .main {
    width: 1200px;
    min-height: 644px;
    padding-bottom: 28px;
    background: var(--bg-card, #FFFFFF);
    border-radius: 4px;
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
    overflow: hidden;

    .main_top {
      height: 250px;
      background:
        linear-gradient(135deg, rgba(26, 29, 36, 0.88) 0%, rgba(26, 29, 36, 0.72) 100%),
        url("../../assets/image/HelpCenter/bg_top.png") center top no-repeat;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      .main_top_wrapper {
        position: relative;
        z-index: 1;
        width: 500px;
        text-align: center;
        padding-top: 34px;

        .help_title {
          margin-bottom: 22px;
          font-size: 28px;
          line-height: 38px;
          font-family: PingFang SC, PingFang SC-Semibold;
          font-weight: 600;
          color: #FFFFFF;
          text-shadow: 0 8px 18px rgba(26, 29, 36, 0.18);
        }

        /deep/ .el-input {
          width: 100%;
        }

        /deep/ .el-input__inner {
          height: 52px;
          border-radius: 4px;
          padding-left: 56px;
          padding-right: 44px;
          font-size: 15px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: var(--text-main, #111827);
          border: 1px solid rgba(255, 255, 255, 0.68);
          background: rgba(255, 255, 255, 0.96);
          box-shadow: 0 14px 34px rgba(26, 29, 36, 0.18);
          transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

          &:hover {
            border-color: #FFFFFF;
            background: #FFFFFF;
            box-shadow: 0 18px 40px rgba(26, 29, 36, 0.24);
          }

          &:focus {
            border-color: var(--primary, #FF5A1F);
            background: #FFFFFF;
            box-shadow: none;
          }
        }

        /deep/ .el-input__prefix {
          width: 18px;
          height: 18px;
          top: calc(50% - 9px);
          left: 26px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }

    .main_content {
      position: relative;
      top: -58px;
      left: 50%;
      width: 1036px;
      transform: translateX(-50%);
      z-index: 1;
    }
  }
}

.help_question {
  min-height: 432px;

  .question_top {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 18px;
    align-items: stretch;

    .el-card {
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      font-size: 15px;
      line-height: 22px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: var(--text-main, #111827);
      cursor: pointer;
      background: var(--bg-card, #FFFFFF);
      box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
      transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease, color 0.2s ease;

      &:hover {
        transform: translateY(-3px);
        color: var(--primary, #FF5A1F);
        border-color: rgba(26, 29, 36, 0.32);
        box-shadow: 0 16px 34px rgba(26, 29, 36, 0.12);
      }

      img {
        width: 52px;
        height: 52px;
        margin-bottom: 12px;
      }
    }
  }

  .question_middle {
    height: 156px;
    margin: 18px 0;
    padding: 26px 0 0 54px;
    box-sizing: border-box;
    border: 1px solid rgba(26, 29, 36, 0.12);
    border-radius: 4px;
    font-family: PingFang SC, PingFang SC-Semibold;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    cursor: pointer;
    background:
      linear-gradient(90deg, rgba(240, 237, 232, 0.96) 0%, rgba(247, 245, 242, 0.68) 48%, rgba(255, 255, 255, 0.2) 100%),
      url("../../assets/image/HelpCenter/questionBg.png") center right no-repeat;
    background-size: cover;
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;

    &:hover {
      transform: translateY(-2px);
      border-color: rgba(26, 29, 36, 0.24);
      box-shadow: 0 16px 34px rgba(26, 29, 36, 0.12);
    }

    .title {
      font-weight: 600;
      color: var(--text-main, #111827);
      font-size: 22px;
      line-height: 30px;
    }

    .text_dec {
      display: block;
      margin: 9px 0 16px;
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
    }

    .qes_btn {
      min-width: 104px;
      height: 32px;
      padding: 0 14px;
      border: none;
      border-radius: 3px;
      font-size: 14px;
      font-weight: 400;
      line-height: 32px;
      color: #FFFFFF;
      background: var(--primary, #FF5A1F);
      box-shadow: none;
      transition: background 0.2s ease;

      &:hover {
        background: var(--primary-hover, #E84A12);
      }

      i {
        margin-left: 4px;
      }
    }
  }

  .question_bottom {
    position: relative;
    min-height: 104px;
    padding: 8px 12px;
    box-sizing: border-box;
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    background: var(--bg-card, #FFFFFF);
    box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

    .swiper-container {
      height: 88px;
      margin: 0 46px;
      padding: 0;
      position: static;
      overflow: hidden;

      /deep/ .swiper-wrapper {
        align-items: center;
      }

      .swiper-slide {
        width: 146px;
        height: 82px;
        margin-top: 3px;
        background: var(--bg-section, #F7F5F2);
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: transform 0.2s ease, border-color 0.2s ease, background 0.2s ease;

        &:hover {
          transform: translateY(-2px);
          border-color: rgba(26, 29, 36, 0.28);
          background: #FFFFFF;

          .detail_btn {
            color: var(--primary, #FF5A1F);
          }
        }

        > div {
          width: 118px;
        }

        .swiper_top {
          display: flex;
          align-items: center;
          margin-bottom: 8px;

          img {
            flex: 0 0 auto;
            width: 13px;
            height: 13px;
            margin-right: 6px;
          }

          .swiper_title {
            display: flex;
            align-items: center;
            width: 118px;
            min-width: 0;
            font-size: 14px;
            line-height: 20px;
            font-family: PingFang SC, PingFang SC-Semibold;
            font-weight: 600;
            text-align: left;
            color: var(--text-main, #111827);
            overflow: hidden;
            white-space: nowrap;

            .swiper_title_text {
              display: block;
              min-width: 0;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }

        .detail_btn {
          display: inline-flex;
          align-items: center;
          height: 20px;
          font-size: 13px;
          line-height: 20px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          text-align: left;
          color: var(--text-secondary, #5A5F6B);
          transition: color 0.2s ease;

          i {
            margin-left: 3px;
          }
        }
      }

      .swiper-button-prev,
      .swiper-button-next {
        width: 28px;
        height: 48px;
        left: 12px;
        top: 50%;
        margin-top: 0;
        transform: translateY(-50%);
        background: var(--bg-tag, #F0EDE8);
        font-size: 18px;
        line-height: 48px;
        text-align: center;
        color: var(--text-muted, #9AA0AC);
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        transition: color 0.2s ease, background 0.2s ease, border-color 0.2s ease;

        &:hover {
          background: #FFFFFF;
          color: var(--primary, #FF5A1F);
          border-color: rgba(26, 29, 36, 0.24);
        }
      }

      .swiper-button-next {
        left: auto;
        right: 12px;
      }
    }
  }
}
</style>
